import { useEffect, useState } from 'react';
import { Spinner } from '../../../components/spinner/spinner';
import { Typography } from '../../../components/typography/typography';
import { DateTime, Interval } from 'luxon';
import { DateTimePicker } from '../../../components/date-picker/date-time-picker';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { UpdateScheduledTimeRequest } from '../../../clients/quipli-service/order/order';

export const ScheduledTimeForm = ({
  orderId,
  orderProductIds,
  scheduledTime,
  timezone,
  disabledIntervals,
  error,
  update,
}: {
  orderId: number;
  orderProductIds: {
    delivery?: number[];
    pickup?: number[];
  };
  scheduledTime?: DateTime;
  timezone?: string;
  disabledIntervals?: Interval[];
  update: () => any;
  error: () => any;
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedDateTime, setSelectedDateTime] = useState<DateTime>();

  const { updateScheduledTime } = useAPI();

  useEffect(() => {
    setSelectedDateTime(scheduledTime);
  }, []);

  const onSubmit = async () => {
    setIsLoading(true);
    try {
      const body: UpdateScheduledTimeRequest = {
        orderId: orderId,
        orderProductIds: orderProductIds,
        scheduledTime: selectedDateTime,
      };
      await updateScheduledTime(orderId, body);
      update();
    } catch (err) {
      console.error(err);
      error && error();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="dialog-actions !px-0 !pb-0">
        <div className={'flex flex-col sm:flex-row actionsContainer'}>
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              <DateTimePicker
                value={selectedDateTime}
                timezone={timezone}
                disabledIntervals={disabledIntervals}
                clearable={true}
                onChange={setSelectedDateTime}
              />
              <button className="button button-yellow button-primary mb-2" onClick={onSubmit}>
                <Typography type="text-sm" weight="semi-bold" className="text-quipli-black-800">
                  Update
                </Typography>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
